import Reflux from "reflux";

var DomainSettingsActions = Reflux.createActions([
  "changeTab",
  "editSettings",
  "saveSettings",
  "undoSettingsChange",
  "openDialog",
  "closeDialog",
  "updateProperty",
  "redirectDelete",
  "submitAddForm",
  "updateAddForm",
]);

export default DomainSettingsActions;
